"use client";

import React, { useState } from "react";
import AnalyticsSidebar from "../../AnalyticsSidebar";
import { Navbar } from "../../../../components/navbar";
import { Footer } from "../../../../components/footer";
import DatePicker from "../../../../components/DatePicker";
import styles from "../css/DmeandForecast.module.css";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const data = [
  { name: "Jan", value: 5 },
  { name: "Feb", value: 10 },
  { name: "Mar", value: 18 },
  { name: "Apr", value: 21 },
  { name: "May", value: 25 },
];

export default function DemandForecasting() {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  return (
    <div className={styles.app}>
      <div className={styles.mainContainer}>
        <Navbar backTo="/analytics" />

        <div className={`${styles.contentArea} analytics-content`}>
          <AnalyticsSidebar />
          <div className={styles.contentAreaFull}>
            <section className={styles.panelArea}>
              <h2 className={styles.pageTitle}>Demand Forecasting</h2>

              <div className={styles.filtersRow}>
                <div className={styles.inlineFilter}>
                  <span>From</span>
                  <DatePicker
                    selectedDate={fromDate}
                    onDateChange={setFromDate}
                    allowTextInput={true}
                    dateFormat="dd/MM/yyyy"
                    showMonthYearDropdowns={false}
                    placeholder="Select date"
                  />
                </div>
                <div className={styles.inlineFilter}>
                  <span>To</span>
                  <DatePicker
                    selectedDate={toDate}
                    onDateChange={setToDate}
                    allowTextInput={true}
                    dateFormat="dd/MM/yyyy"
                    showMonthYearDropdowns={false}
                    placeholder="Select date"
                  />
                </div>
              </div>

              <div className={styles.chartCard}>
                <div className={styles.chartInner}>
                  <ResponsiveContainer width="100%" height={360}>
                    <LineChart data={data} margin={{ left: 24, right: 24, top: 16, bottom: 16 }}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                      <YAxis />
                      <Tooltip />
                      <Legend formatter={() => "Influenza sales during Winter"} />
                      <Line type="monotone" dataKey="value" stroke="#7C3AED" strokeWidth={3} dot={{ r: 4 }} isAnimationActive={true}
                        animationDuration={850}
                        animationEasing="linear" />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div className={styles.footerWrapper}>
          <Footer />
        </div>
      </div>
    </div>
  );
}
